import React from 'react';
import { pick } from 'lodash';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import('./Item.sass');

interface ItemProps {
	id: string;
	name: string;
	icon?: string;
	impact?: string;
	trend?: string;
	selected?: boolean;
	fade?: boolean;
	isResizing?: boolean;
	isExternallyCreated?: boolean;
	isExternallyUpdated?: boolean;
	isEntering?: boolean;
	style?: React.CSSProperties;
	onMouseDown?: (e: React.MouseEvent) => void;
	onTouchStart?: (e: React.TouchEvent) => void;
	onDoubleClick?: (e: React.MouseEvent) => void;
	onClick?: (e: React.MouseEvent) => void;
}

const Item = React.memo(function Item(props: ItemProps) {
	const {
		id,
		name,
		icon,
		impact,
		trend,
		selected,
		fade,
		isResizing,
		isExternallyCreated,
		isEntering,
	} = props;

	const classNames = [
		'ItemWrapper',
		impact === 'medium' ? 'impactMedium' : '',
		impact === 'high' ? 'impactHigh' : '',
		trend === 'red' ? 'trendNegative' : '',
		trend === 'orange' ? 'trendAtRisk' : '',
		trend === 'green' ? 'trendPositive' : '',
		fade ? 'fade' : '',
		isResizing ? 'isResizing' : '',
		isExternallyCreated ? 'externallyCreated' : '',
		isEntering ? 'entering' : '',
	].filter(Boolean).join(' ');

	return (
		<div
			id={`Item-${id}`}
			className={classNames}
			{...pick(props, ['onMouseDown', 'onTouchStart', 'onDoubleClick', 'onClick'])}
		>
			<div className="aura" />
			<div className="aura-double" />
			<svg
				viewBox="-50 -50 100 100"
				className={`Item noselection ${selected ? 'selected' : ''}`}
			>
				<g>
					<circle
						className="selection"
						cx={0}
						cy={0}
						r={48}
						stroke="orange"
						strokeWidth={4}
						strokeDasharray="8 8"
						fill="none"
					/>
					<circle className="main" cx={0} cy={0} r={30} />
					<FontAwesomeIcon
						x="-17.5"
						y="-18"
						width={35}
						height={35}
						color="black"
						icon={(icon ? fal[icon] : fal['faUser']) as IconProp}
					/>
				</g>
			</svg>
			<div className="ItemText noselection">{name}</div>
		</div>
	);
});

export default Item;
